var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"title":_vm.$t('listing.candidates.title'),"icon":"mdi-account-group"}}),_c('CandidatesList',{on:{"add-candidate":_vm.redirectNewCandidate,"show-candidate-details":_vm.candidateDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }